import { useGrowthBook } from '@growthbook/growthbook-react';
import { useEffect } from 'react';
import * as gtagAnalytics from '../gtagAnalytics';
import { getDeviceId } from '../growthbook';

export const useGrowthBookSetup = (user) => {
  const growthbook = useGrowthBook();

  useEffect(() => {
    growthbook.setAttributes({
      ...(user
        ? {
            id: user?.ID,
            email: user?.Email,
          }
        : {}),
      clientId: getDeviceId(),
    });
  }, [growthbook, user]);

  useEffect(() => {
    growthbook.setTrackingCallback((experiment, result) => {
      gtagAnalytics.experimentViewed({
        experiment_id: experiment.key,
        variation_id: result.key,
      });
    });
  }, [growthbook]);

  return null;
};
